import React, { useEffect, useRef, useState } from "react";
import "./chatbotheader.scss";
import BotIcon from "../../../assets/icons/bot.svg";
import { useDispatch, useSelector } from "react-redux";
import MenuIcon from "../../../assets/icons/3-menu-icon.png";
import { clearChat } from "../../../store/slices/projectSlice";
import { useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import useOnClickOutside from "../../../common/Hooks/useOnClickOutside";
export default function Chatbotheader({
  BgColor,
  tempUserData,
  setChatWithBot,
}) {
  const { selectedProject } = useSelector((state) => state.project);
  const { user } = useSelector((state) => state.auth);
  const menuref = useRef();
  const [boyIcon, setBotIcon] = useState();
  const [isMenu, setIsMenu] = useState(false);
  const dispatch = useDispatch();
  const { pathname } = useLocation();

  useOnClickOutside(menuref, () => setIsMenu(false));
  useEffect(() => {
    const BotImage =
      selectedProject?.bot_image instanceof Blob ||
        selectedProject?.bot_image instanceof File
        ? URL.createObjectURL(selectedProject?.bot_image)
        : typeof selectedProject?.bot_image == "string"
          ? selectedProject?.bot_image
          : BotIcon;
    setBotIcon(BotImage);
  }, [selectedProject?.bot_image]);
  const handleClearChat = () => {
    // Get the correct project ID - use project_id for public chat, id for authenticated chat
    const projectId = selectedProject?.project_id || selectedProject?.id;

    // Generate a stable admin-preview session ID if none available
    const adminPreviewSessionId =
      localStorage.getItem("admin_preview_session_id") ||
      (() => {
        const id = `admin-preview-${Date.now()}`;
        localStorage.setItem("admin_preview_session_id", id);
        return id;
      })();

    let body = {
      payload: {
        project_id: projectId,
        session_id:
          pathname.includes("generalchat") || pathname.includes("/chat/")
            ? (tempUserData || adminPreviewSessionId)
            : (user?.session_id || adminPreviewSessionId),
      },
      route:
        pathname.includes("generalchat") || pathname.includes("/chat/")
          ? "clear_pub_chat"
          : "clear_chat",
    };
    dispatch(clearChat(body))
      .unwrap()
      .then((res) => {
        if (!res?.data?.success) {
          toast.error(res?.data?.message);
          return;
        }
        toast.success(res?.data?.message);
        setChatWithBot([]);
      });
  };

  return (
    <>
      <div
        className="chat-bot-header"
        style={{
          background: selectedProject?.base_color?.includes("gradient")
            ? selectedProject?.base_color
            : `linear-gradient(180deg, ${BgColor} 0%, ${selectedProject?.base_color} 100%)`,
        }}
      >
        <div className="header-design">
          <img src={boyIcon} alt="BotIcon" />
          <div className="bot-name-group">
            <p style={{ color: selectedProject?.text_color }}>
              {selectedProject?.bot_name}
              <span className="online-badge"></span>
            </p>
          </div>
        </div>


        <div className="menu-icon" ref={menuref}>
          <div onClick={() => setIsMenu(!isMenu)}>
            <img src={MenuIcon} alt="menu-icon" />
          </div>
          {isMenu && (
            <div className="menu-item" onClick={() => handleClearChat()}>
              <span>Clear Chat</span>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
